module.exports = __webpack_public_path__ + "SourceSansPro-SemiBold.0031bc165e7dfead8dd4.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-SemiBold.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-SemiBold.eot
// module chunks = styles